document.addEventListener('DOMContentLoaded', function () {
    var rootEl = document.documentElement;
    var bodyEl = document.body;
    var themeColorMeta = document.getElementById('theme-color-meta') || document.querySelector('meta[name="theme-color"]');
    var chromeTone = '';
    var CHROME_COLOR_HERO = '#125C85';
    var CHROME_COLOR_LIGHT = '#ffffff';

    var fixedBgEl = document.querySelector('.wl-hero-fixed-bg');
    var tintTopEl = document.querySelector('.wl-chrome-tint-top');
    var tintBottomEl = document.querySelector('.wl-chrome-tint-bottom');
    var ctaPin = document.querySelector('.wl-cta-pin');
    var heroElForIntro = document.querySelector('.wl-hero');

    if (heroElForIntro) {
        window.requestAnimationFrame(function () {
            window.setTimeout(function () {
                heroElForIntro.classList.add('is-loaded');
            }, 120);
        });
    }

    function setBrowserChromeTone(nextColor) {
        if (chromeTone === nextColor) return;

        chromeTone = nextColor;
        rootEl.style.backgroundColor = nextColor;
        bodyEl.style.backgroundColor = nextColor;

        if (themeColorMeta) {
            themeColorMeta.setAttribute('content', nextColor);
        }

        /* Safari 26 reads background-color from fixed elements for toolbar tint.
           Hide blue fixed elements when in light sections so toolbar turns white. */
        var isLight = nextColor === CHROME_COLOR_LIGHT;
        if (fixedBgEl) fixedBgEl.style.display = isLight ? 'none' : '';
        if (tintTopEl) tintTopEl.style.display = isLight ? 'none' : '';
        if (tintBottomEl) tintBottomEl.style.display = isLight ? 'none' : '';

        /* Avoid forcing a no-op scroll here: on mobile Safari it can interrupt
           inertial scrolling exactly when the CTA fade starts. */
    }

    function getPinProgress(pinEl) {
        if (!pinEl) return null;

        var rect = pinEl.getBoundingClientRect();
        var scrollable = pinEl.offsetHeight - window.innerHeight;

        if (scrollable <= 0) {
            return {
                rect: rect,
                progress: rect.top <= 0 ? 1 : 0
            };
        }

        var scrolled = -rect.top;

        return {
            rect: rect,
            progress: Math.max(0, Math.min(1, scrolled / scrollable))
        };
    }

    /** Join Waitlist ピン：上端が sticky 原点に付く前（progress=0）でも、viewport に入ったら薄く出す */
    function ctaPinEnterFadeFromRect(rect) {
        var vh = window.innerHeight || 1;
        var pinTop = rect.top;
        var fadeStart = vh * 1.18;
        var fadeDistance = vh * 1.1;
        if (pinTop >= fadeStart) return 0;
        return Math.max(0, Math.min(1, (fadeStart - pinTop) / fadeDistance));
    }

    var HERO_TIMELINE_SCALE = 1;

    function heroScaledProgress(raw) {
        return Math.max(0, Math.min(1, raw * HERO_TIMELINE_SCALE));
    }

    function heroProgressBand(progress, start, end) {
        if (progress <= start) return 0;
        if (progress >= end) return 1;
        return (progress - start) / (end - start);
    }

    /* スクロール同期の見た目：線形より smoothstep で両端を柔らげる */
    function scrollEase01(t) {
        if (t <= 0) return 0;
        if (t >= 1) return 1;
        return t * t * (3 - 2 * t);
    }

    function heroEasedBand(progress, start, end) {
        return scrollEase01(heroProgressBand(progress, start, end));
    }

    function heroLogBand(progress, start, end) {
        var t = heroProgressBand(progress, start, end);
        return Math.log(1 + t * 9) / Math.log(10);
    }

    /* 目標透明度に毎フレーム追従（1=即応、値を下げるほどスクロールに「重み」）。 */
    function chaseOpacityToward(previous, target, strength) {
        if (previous === null || previous === undefined) return target;
        return previous + (target - previous) * strength;
    }

    /*
     * Concept card + “2026年秋…” register: same hold length.
     * The pin height is shortened in CSS, so the same complete timeline has roughly half
     * the physical scroll distance without leaving a sticky tail after the final fade.
     */
    /* “私が私を…”のフェード帯は旧 ~0.3→0.64 の約四分の一に縮める。 */
    var CARD_FADE_IN_START = 0.3;
    var CARD_FADE_SCROLL_SPAN = (0.64 - 0.3) / 4;
    var CARD_FADE_IN_END = CARD_FADE_IN_START + CARD_FADE_SCROLL_SPAN;
    var BLUR_FADE_IN_START = CARD_FADE_IN_START - 0.07;
    var BLUR_FADE_IN_END = CARD_FADE_IN_END;
    var HERO_CROSSFADE_SPAN = 0.14;
    var HERO_FADE_IN_SPAN = HERO_CROSSFADE_SPAN;
    var HERO_FADE_OUT_SPAN = HERO_CROSSFADE_SPAN;
    /* LINE から Philosophy への移行は fixed 面同士でゆっくりクロスフェードする。 */
    var REGISTER_FADE_OUT_SPAN = 0.16;

    var HERO_HOLD_PLATEAU_LEN =
        (1 -
            CARD_FADE_IN_END -
            HERO_CROSSFADE_SPAN -
            REGISTER_FADE_OUT_SPAN) /
        2;

    var CARD_FADE_OUT_START = CARD_FADE_IN_END + HERO_HOLD_PLATEAU_LEN;
    var CARD_FADE_OUT_END = CARD_FADE_OUT_START + HERO_FADE_OUT_SPAN;

    var REGISTER_FADE_IN_START = CARD_FADE_OUT_START;
    var REGISTER_FADE_IN_END = REGISTER_FADE_IN_START + HERO_FADE_IN_SPAN;
    var REGISTER_FADE_OUT_START = REGISTER_FADE_IN_END + HERO_HOLD_PLATEAU_LEN;
    var REGISTER_FADE_OUT_END = REGISTER_FADE_OUT_START + REGISTER_FADE_OUT_SPAN;
    var PHILOSOPHY_HANDOFF_START_VH = 0;

    function registerFadePoint(ratio) {
        return REGISTER_FADE_OUT_START +
            (REGISTER_FADE_OUT_END - REGISTER_FADE_OUT_START) * ratio;
    }

    function cardOverlayOpacity(progress) {
        if (progress < CARD_FADE_IN_START) return 0;
        if (progress < CARD_FADE_IN_END) {
            return heroEasedBand(progress, CARD_FADE_IN_START, CARD_FADE_IN_END);
        }
        if (progress < CARD_FADE_OUT_START) return 1;
        return 1 - heroEasedBand(progress, CARD_FADE_OUT_START, CARD_FADE_OUT_END);
    }

    function registerOverlayOpacity(progress) {
        if (progress < REGISTER_FADE_IN_START) return 0;
        if (progress < REGISTER_FADE_IN_END) {
            return heroEasedBand(progress, REGISTER_FADE_IN_START, REGISTER_FADE_IN_END);
        }
        if (progress < REGISTER_FADE_OUT_END) return 1;
        return 0;
    }

    function registerSceneOpacity(progress) {
        if (progress < REGISTER_FADE_OUT_START) return 1;
        if (progress < REGISTER_FADE_OUT_END) {
            return 1 - heroEasedBand(progress, REGISTER_FADE_OUT_START, REGISTER_FADE_OUT_END);
        }
        return 0;
    }

    function shouldForceCtaWhiteLogo() {
        if (!ctaPin) return false;
        var rect = ctaPin.getBoundingClientRect();
        return -rect.top > 0 || ctaPinEnterFadeFromRect(rect) > 0.22;
    }

    function isSpViewport() {
        return !!(window.matchMedia && window.matchMedia('(max-width: 767px)').matches);
    }

    /* ---------------------------------------------------------- */
    /* Viewport height fix (iOS 26 floating toolbar)              */
    /* ---------------------------------------------------------- */
    function setVh() {
        document.documentElement.style.setProperty('--vh', window.innerHeight + 'px');
    }
    setVh();
    window.addEventListener('resize', function () {
        setVh();
        updateChromeTone();
    });

    /* ---------------------------------------------------------- */
    /* Hero pinned scroll                                         */
    /*   parallax → blur → card → register → fade-out             */
    /* ---------------------------------------------------------- */
    var heroPin = document.querySelector('.wl-hero-pin');
    var heroEl = document.querySelector('.wl-hero');
    var heroImageEls = Array.from(document.querySelectorAll('[data-hero-img]'));
    var imageCount = heroImageEls.length;
    var blurEl = document.querySelector('.wl-hero__blur');
    var cardEl = document.querySelector('.wl-hero__card');
    var registerEl = document.querySelector('.wl-hero__register');
    var fadeoutEl = document.querySelector('.wl-hero__fadeout');
    var heroBottomEl = document.querySelector('.wl-hero__bottom');
    var logoEl = document.querySelector('.wl-logo');
    var textVerticalEls = Array.from(document.querySelectorAll('.wl-hero__text-vertical'));
    var philosophyEl = document.querySelector('.wl-philosophy');
    var philosophyArtShellEl = document.querySelector('.wl-philosophy__art-shell');
    var philosophyArtEl = document.querySelector('.wl-philosophy__art');
    var philosophyArtImageEls = Array.from(document.querySelectorAll('.wl-philosophy__art-img'));
    var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* First-view: quicker staged reveals (base thresholds ÷3 vs original 1×) + livelier parallax. */
    var HERO_FIRSTVIEW_SPEED = 3;
    var HERO_IMG_SCRUB_FADE = 0.03;
    /* Equal progress gap 1→2 and 2→3; midpoint = (first + third) / 2. */
    var IMG_REVEAL_FIRST = 0.084 / HERO_FIRSTVIEW_SPEED;
    var IMG_REVEAL_THIRD = 0.448 / HERO_FIRSTVIEW_SPEED;
    var IMG_GAP_12_OR_23 = (IMG_REVEAL_THIRD - IMG_REVEAL_FIRST) / 2;
    var heroImageRevealProgress = [
        IMG_REVEAL_FIRST,
        IMG_REVEAL_FIRST + IMG_GAP_12_OR_23,
        IMG_REVEAL_THIRD
    ];
    var parallaxSpeeds = [-80 * HERO_FIRSTVIEW_SPEED, 120 * HERO_FIRSTVIEW_SPEED, -60 * HERO_FIRSTVIEW_SPEED];
    /* ヒーローの opacity は chase で微遅延；値を下げるほど重い。パララックス transform は生 progress。 */
    var HERO_OPACITY_CATCH_STRENGTH = 0.065;
    var chaseHeroBlur = null;
    var chaseHeroCard = null;
    var chaseHeroRegister = null;
    var chaseHeroFadeout = null;
    var chaseHeroBottom = null;
    var chaseHeroLogoFo = null;
    var chaseHeroImgOp = [];
    var heroChaseRaf = null;
    var ticking = false;
    var philosophyParallaxTicking = false;

    function runHeroFrame() {
        updateHero();
    }

    function updateChromeTone() {
        var heroState = getPinProgress(heroPin);
        var ctaState = getPinProgress(ctaPin);
        var heroNeedsBlue = false;
        var ctaNeedsBlue = false;

        if (heroState) {
            var heroP = heroScaledProgress(heroState.progress);
            var heroSceneOp = registerSceneOpacity(heroP);
            var regChase = typeof chaseHeroRegister === 'number' ? chaseHeroRegister : 0;
            heroNeedsBlue =
                heroState.rect.bottom > 0 &&
                heroState.rect.top < window.innerHeight &&
                (heroP < REGISTER_FADE_OUT_END || heroSceneOp > 0.03 || regChase > 0.03);
        }

        if (ctaState) {
            var ctaEnter = ctaPinEnterFadeFromRect(ctaState.rect);
            var ctaPrewarm = ctaState.rect.top < window.innerHeight * 1.25;
            ctaNeedsBlue =
                ctaState.rect.bottom > 0 &&
                ctaPrewarm &&
                ctaState.rect.bottom > window.innerHeight * 0.95 &&
                (ctaState.progress > 0.02 || ctaEnter > 0.02);
        }

        setBrowserChromeTone(heroNeedsBlue || ctaNeedsBlue ? CHROME_COLOR_HERO : CHROME_COLOR_LIGHT);
    }

    /*
     * Timeline (0 → 1 in updateHero = heroScaledProgress(raw)):
     *   Image reveals: first/third from [0.084,?,?,0.448]÷HERO_FIRSTVIEW_SPEED; midpoint evenly spaced.
     *   Last image → CARD_FADE_IN_START  hold (all images + parallax)
     *   opacity は smoothstep の目標値を chase で逐次追従（完全同期のみより手触りが重め）
     *   … register / fade-out … see CARD_* / REGISTER_* constants
     */

    function updateHero() {
        if (!heroPin) return;

        var heroState = getPinProgress(heroPin);
        var progress = heroState ? heroScaledProgress(heroState.progress) : 0;

        var k = HERO_OPACITY_CATCH_STRENGTH;
        /* 追従完了判定にも使う共通ターゲット */
        var blurTarget =
            !blurEl || progress < BLUR_FADE_IN_START
                ? 0
                : heroLogBand(progress, BLUR_FADE_IN_START, BLUR_FADE_IN_END);
        var cardTarget = cardEl ? cardOverlayOpacity(progress) : 0;
        var regTarget = registerEl ? registerOverlayOpacity(progress) : 0;
        var sceneTarget = registerSceneOpacity(progress);
        var registerSceneActive =
            progress >= REGISTER_FADE_IN_START &&
            (progress < REGISTER_FADE_OUT_END || regTarget > 0.02 || sceneTarget > 0.02);
        var registerFixedOpacity = regTarget * sceneTarget;
        var philosophyHandoffT = heroEasedBand(progress, registerFadePoint(0), registerFadePoint(1));
        var philosophyShellRect = philosophyArtShellEl ? philosophyArtShellEl.getBoundingClientRect() : null;
        var philosophyHandoffStart = window.innerHeight * PHILOSOPHY_HANDOFF_START_VH;
        var philosophyIntroY = Math.min(120, Math.max(64, window.innerHeight * 0.1));
        var registerFadeOutT = philosophyHandoffT > 0 ? 1 - registerFixedOpacity : 0;
        var philosophyFixedTop = philosophyHandoffStart + (1 - registerFadeOutT) * philosophyIntroY;
        var philosophyShellTop = philosophyShellRect ? philosophyShellRect.top : Infinity;
        var philosophyHandoffActive =
            !!(philosophyArtShellEl && philosophyHandoffT > 0 && philosophyShellTop > philosophyFixedTop);
        var philosophyHandoffReleased =
            !!(philosophyArtShellEl && philosophyHandoffT > 0 && !philosophyHandoffActive);
        var philosophyArtOpacity = philosophyHandoffActive
            ? registerFadeOutT
            : philosophyHandoffReleased
              ? 1
              : 0;
        var philosophyArtBlur = philosophyHandoffActive
            ? Math.pow(1 - registerFadeOutT, 1.15) * 18
            : 0;
        var philosophySurfaceT = Math.max(philosophyHandoffT, philosophyHandoffReleased ? 1 : 0);
        /* Fade the fixed blue surface with the same curve as the 2026 register copy. */
        var blueSurfaceOpacity = philosophyHandoffT > 0 ? registerFixedOpacity : 1;
        var heroTintOpacity = cardTarget;
        var preRegisterLayerOpacity = registerSceneActive ? sceneTarget : 1;
        var heroImageLayerOpacity = registerSceneActive
            ? sceneTarget * Math.pow(1 - regTarget, 1.8)
            : 1;
        var isSp = isSpViewport();
        var philosophyHandoffBgOpacity = philosophyHandoffActive ? registerFadeOutT : 0;
        var philosophyBgT = philosophyHandoffReleased ? 1 : 0;
        var forceLogoWhiteChrome = !!shouldForceCtaWhiteLogo();
        var logoTarget = logoEl
            ? forceLogoWhiteChrome
                ? 0
                : philosophySurfaceT
            : 0;

        if (heroEl) {
            heroEl.style.opacity = registerSceneActive ? '1' : String(sceneTarget);
            heroEl.style.pointerEvents = sceneTarget > 0.02 ? '' : 'none';
            heroEl.classList.toggle('is-register-scene-active', registerSceneActive);
        }

        if (fixedBgEl) {
            fixedBgEl.style.opacity =
                registerSceneActive || philosophyHandoffT > 0
                    ? String(blueSurfaceOpacity)
                    : '';
        }

        if (chaseHeroImgOp.length !== imageCount) {
            chaseHeroImgOp.length = imageCount;
            for (var g = 0; g < imageCount; g++) {
                chaseHeroImgOp[g] = null;
            }
        }

        var parallaxProgress = Math.min(progress, CARD_FADE_IN_START);

        for (var i = 0; i < imageCount; i++) {
            var revealAt = heroImageRevealProgress[i];
            var imgTarget =
                revealAt === undefined
                    ? 0
                    : progress < revealAt
                      ? 0
                      : heroEasedBand(progress, revealAt, revealAt + HERO_IMG_SCRUB_FADE);
            chaseHeroImgOp[i] = chaseOpacityToward(chaseHeroImgOp[i], imgTarget, k);
            var displayedImgOpacity = chaseHeroImgOp[i] * heroImageLayerOpacity;
            heroImageEls[i].style.opacity = String(displayedImgOpacity);

            var speed = parallaxSpeeds[i] || 0;
            var yOffset = parallaxProgress * speed;
            heroImageEls[i].style.transform = 'translateY(' + yOffset + 'px)';
        }

        if (blurEl) {
            chaseHeroBlur = chaseOpacityToward(chaseHeroBlur, blurTarget, k);
            var blurSceneOpacity = registerSceneActive ? Math.pow(1 - regTarget, 1.8) : preRegisterLayerOpacity;
            blurEl.style.opacity = String(Math.max(chaseHeroBlur * blurSceneOpacity, heroTintOpacity));
        }

        if (cardEl) {
            chaseHeroCard = cardTarget;
            cardEl.style.opacity = String(chaseHeroCard);
        }

        if (registerEl) {
            chaseHeroRegister = registerFixedOpacity;
            registerEl.style.opacity = String(chaseHeroRegister);
            registerEl.style.pointerEvents = chaseHeroRegister > 0.08 ? 'auto' : 'none';
            /*
             * LINE 章全体を viewport 固定（フェードイン直後から chase が 0 になるまで）。
             * progress だけではフェードアウト末尾でまだ chase > 0 の間に切れるので
             * regTarget / chase でテールを伸ばす。フェードイン先頭は 0 でも
             * progress < REGISTER_FADE_OUT_END でロックする。
             */
            var registerViewportLock =
                progress >= REGISTER_FADE_IN_START &&
                (progress < REGISTER_FADE_OUT_END ||
                    regTarget > 0.02 ||
                    chaseHeroRegister > 0.02);
            registerEl.classList.toggle('is-register-viewport-lock', registerViewportLock);
        }

        if (fadeoutEl) {
            chaseHeroFadeout = philosophyHandoffT > 0 ? blueSurfaceOpacity : 0;
            fadeoutEl.style.opacity = String(chaseHeroFadeout);
        }

        if (philosophyArtEl) {
            philosophyArtEl.style.setProperty(
                '--wl-philosophy-art-opacity',
                String(philosophyArtOpacity)
            );
            philosophyArtEl.style.opacity = String(philosophyArtOpacity);
            philosophyArtEl.style.setProperty(
                '--wl-philosophy-art-y',
                '0px'
            );
            philosophyArtEl.style.setProperty(
                '--wl-philosophy-art-blur',
                philosophyArtBlur.toFixed(2) + 'px'
            );
            if (philosophyShellRect) {
                philosophyArtEl.style.setProperty('--wl-philosophy-fixed-top', philosophyFixedTop + 'px');
                philosophyArtEl.style.setProperty('--wl-philosophy-fixed-left', philosophyShellRect.left + 'px');
                philosophyArtEl.style.setProperty('--wl-philosophy-fixed-width', philosophyShellRect.width + 'px');
                philosophyArtEl.style.setProperty('--wl-philosophy-fixed-height', philosophyShellRect.height + 'px');
            }
            philosophyArtEl.classList.toggle('is-handoff-fixed', philosophyHandoffActive);
            if (philosophyHandoffActive) {
                philosophyArtImageEls.forEach(function (el) {
                    el.style.setProperty('--wl-philosophy-parallax-y', '0px');
                });
            }
        }

        if (philosophyEl) {
            philosophyEl.classList.toggle('is-handoff-active', philosophyHandoffActive);
            philosophyEl.style.setProperty(
                '--wl-philosophy-handoff-bg-opacity',
                String(philosophyHandoffBgOpacity)
            );
            philosophyEl.style.setProperty(
                '--wl-philosophy-bg-opacity',
                String(philosophyBgT)
            );
        }

        if (heroBottomEl) {
            chaseHeroBottom = 0;
            heroBottomEl.style.opacity = String(registerSceneActive ? registerFixedOpacity : sceneTarget);
            heroBottomEl.style.pointerEvents = (registerSceneActive ? registerFixedOpacity : sceneTarget) > 0.02 ? '' : 'none';
            var bottomViewportLock =
                progress >= REGISTER_FADE_IN_START &&
                (progress < REGISTER_FADE_OUT_END || registerFixedOpacity > 0.02);
            heroBottomEl.classList.toggle('is-hero-bottom-viewport-lock', bottomViewportLock);
        }

        if (logoEl) {
            chaseHeroLogoFo = chaseOpacityToward(chaseHeroLogoFo, logoTarget, k);
            logoEl.style.setProperty('--wl-logo-dark', String(chaseHeroLogoFo));
            logoEl.style.setProperty('--wl-logo-hidden', '0');
        }

        /* SP: 1枚目画像が出始めたら縦コピーは画面に残さず、画像へ視線を渡す。 */
        var hideHeroCopyOnSpImage =
            isSp &&
            progress >= IMG_REVEAL_FIRST;

        /* LINE 章以降は前段の縦コピーを戻さず、Philosophy へのゴースト表示を防ぐ。 */
        if (textVerticalEls.length) {
            var hideHeroCopy = progress >= REGISTER_FADE_IN_START;
            textVerticalEls.forEach(function (tv) {
                tv.classList.toggle('is-wl-hero-copy-sp-image-hidden', hideHeroCopyOnSpImage);
                tv.classList.toggle('is-wl-hero-copy-handoff-hidden', hideHeroCopy);
            });
        }

        updateChromeTone();

        var eps = 0.004;
        var still =
            blurEl &&
            Math.abs(chaseHeroBlur - blurTarget) > eps;

        var i2;
        for (i2 = 0; i2 < imageCount && !still; i2++) {
            var rat = heroImageRevealProgress[i2];
            var tgt =
                rat === undefined
                    ? 0
                    : progress < rat
                      ? 0
                      : heroEasedBand(progress, rat, rat + HERO_IMG_SCRUB_FADE);
            if (Math.abs(chaseHeroImgOp[i2] - tgt) > eps) still = true;
        }

        if (cardEl && Math.abs(chaseHeroCard - cardTarget) > eps) still = true;
        if (registerEl && Math.abs(chaseHeroRegister - registerFixedOpacity) > eps) still = true;
        if (
            logoEl &&
            (chaseHeroLogoFo === null || Math.abs(chaseHeroLogoFo - logoTarget) > eps)
        ) {
            still = true;
        }

        /* スクロールが止まったあとも opacity が目標に届くように */
        if (still && !heroChaseRaf) {
            heroChaseRaf = requestAnimationFrame(function () {
                heroChaseRaf = null;
                runHeroFrame();
            });
        }
    }

    function onScroll() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(function () {
                runHeroFrame();
                ticking = false;
            });
        }
    }

    if (heroPin) {
        window.addEventListener('scroll', onScroll, { passive: true });
        updateHero();
    }

    function updatePhilosophyParallax() {
        if (!philosophyArtEl || !philosophyArtImageEls.length) return;

        if (prefersReducedMotion || philosophyArtEl.classList.contains('is-handoff-fixed')) {
            philosophyArtImageEls.forEach(function (el) {
                el.style.setProperty('--wl-philosophy-parallax-y', '0px');
            });
            return;
        }

        var rect = philosophyArtEl.getBoundingClientRect();
        var vh = window.innerHeight || 1;

        if (rect.bottom < -vh * 0.25 || rect.top > vh * 1.25) return;

        var stageCenter = rect.top + rect.height * 0.5;
        var viewportCenter = vh * 0.5;
        var scrollT = Math.max(-1, Math.min(1, (viewportCenter - stageCenter) / vh));
        var strengths = [-28, 36, -24, 34, -30];

        philosophyArtImageEls.forEach(function (el, index) {
            var strength = strengths[index] || 0;
            var offset = scrollEase01(Math.abs(scrollT)) * Math.sign(scrollT) * strength;
            el.style.setProperty('--wl-philosophy-parallax-y', offset.toFixed(2) + 'px');
        });
    }

    function onPhilosophyParallaxScroll() {
        if (philosophyParallaxTicking) return;

        philosophyParallaxTicking = true;
        requestAnimationFrame(function () {
            updatePhilosophyParallax();
            philosophyParallaxTicking = false;
        });
    }

    if (philosophyArtEl && philosophyArtImageEls.length) {
        window.addEventListener('scroll', onPhilosophyParallaxScroll, { passive: true });
        window.addEventListener('resize', onPhilosophyParallaxScroll);
        updatePhilosophyParallax();
    }

    /* ---------------------------------------------------------- */
    /* CTA pinned scroll (visibility is CSS-only; no scroll fade) */
    /* ---------------------------------------------------------- */
    var ctaTicking = false;

    function updateCta() {
        if (!ctaPin) return;

        var ctaState = getPinProgress(ctaPin);
        var progress = ctaState ? ctaState.progress : 0;
        var rect = ctaState ? ctaState.rect : ctaPin.getBoundingClientRect();
        var scrolled = -rect.top;
        var enterFade = ctaPinEnterFadeFromRect(rect);

        // Scroll-linked opacity（ピン内 sticky 進行）— 前セクション直後は enterFade で補間し空白感を減らす
        var ctaSection = ctaPin.querySelector('.wl-cta');
        var radialGlow = ctaPin.querySelector('.wl-cta__radial-glow');
        var radialGlowBottom = ctaPin.querySelector('.wl-cta__radial-glow-bottom');
        if (ctaSection) {
            var scrollOpacity;
            if (progress < 0.5) {
                scrollOpacity = progress / 0.5 * 0.5;
            } else if (progress < 0.7) {
                scrollOpacity = 0.5 + (progress - 0.5) / 0.2 * 0.5;
            } else {
                scrollOpacity = 1;
            }
            scrollOpacity = Math.min(1, scrollOpacity);
            var opacity = Math.min(1, Math.max(enterFade, scrollOpacity));
            ctaSection.style.opacity = String(opacity);

            if (radialGlow) {
                var glowScroll = Math.min(0.5, progress / 0.5 * 0.5);
                var glowEnter = enterFade * 0.5;
                var glowOp = String(Math.min(0.5, Math.max(glowEnter, glowScroll)));
                radialGlow.style.opacity = glowOp;
                if (radialGlowBottom) radialGlowBottom.style.opacity = glowOp;
            }
        }

        var ctaBlur = ctaPin.querySelector('.wl-cta__blur');
        if (ctaBlur) {
            var bgFade = scrollEase01(Math.max(enterFade, Math.min(1, progress / 0.18)));
            ctaBlur.style.setProperty('--wl-cta-bg-opacity', String(0.3 + bgFade * 0.7));

            if (scrolled > 0 || enterFade > 0.02) {
                ctaBlur.classList.add('is-visible');
            } else {
                ctaBlur.classList.remove('is-visible');
            }
        }

        updateChromeTone();
    }

    function onCtaScroll() {
        if (!ctaTicking) {
            ctaTicking = true;
            requestAnimationFrame(function () {
                updateCta();
                ctaTicking = false;
            });
        }
    }

    if (ctaPin) {
        window.addEventListener('scroll', onCtaScroll, { passive: true });
        updateCta();
    }

    updateChromeTone();

    /* ---------------------------------------------------------- */
    /* Fade-up animation (IntersectionObserver)                   */
    /* ---------------------------------------------------------- */
    document.body.classList.add('has-wl-animations');

    var fadeEls = Array.from(document.querySelectorAll('.wl-fade-up'));
    var sequenceRoots = Array.from(document.querySelectorAll('[data-wl-sequence]'));
    var standaloneFadeEls = fadeEls.filter(function (el) {
        if (el.hasAttribute('data-wl-sequence-item')) return false;
        return true;
    });

    function revealSequence(root) {
        if (!root || root.dataset.wlSequenceVisible === 'true') return;

        root.dataset.wlSequenceVisible = 'true';
        root.querySelectorAll('[data-wl-sequence-item]').forEach(function (el) {
            el.classList.add('is-visible');
        });
    }

    if ('IntersectionObserver' in window && fadeEls.length) {
        var fadeObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    fadeObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15 });

        var sequenceObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    revealSequence(entry.target.closest('[data-wl-sequence]') || entry.target);
                    sequenceObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15 });

        standaloneFadeEls.forEach(function (el) {
            fadeObserver.observe(el);
        });

        sequenceRoots.forEach(function (root) {
            var trigger = root.querySelector('[data-wl-sequence-trigger]') || root;
            sequenceObserver.observe(trigger);
        });
    } else {
        fadeEls.forEach(function (el) {
            el.classList.add('is-visible');
        });
    }

    /* ---------------------------------------------------------- */
    /* Vertical text floating behaviour                            */
    /* ---------------------------------------------------------- */
    var textEls = document.querySelectorAll('.wl-hero__text-vertical');

    if (heroPin && textEls.length) {
        var pinEnd = heroPin.offsetHeight;

        window.addEventListener('scroll', function () {
            var sy = window.scrollY;

            if (sy < pinEnd - 300) {
                textEls.forEach(function (el) {
                    el.classList.remove('is-floating', 'is-leaving');
                });
            } else if (sy < pinEnd) {
                textEls.forEach(function (el) {
                    el.classList.add('is-floating');
                    el.classList.remove('is-leaving');
                });
            } else {
                textEls.forEach(function (el) {
                    el.classList.add('is-floating', 'is-leaving');
                });
            }
        }, { passive: true });
    }

    /* ---------------------------------------------------------- */
    /* Custom cursor                                               */
    /* ---------------------------------------------------------- */
    function initCustomCursor() {
        if (!window.matchMedia || !window.matchMedia('(pointer: fine) and (hover: hover)').matches) return;

        var dot = document.createElement('div');
        var ring = document.createElement('div');
        var logo = document.createElement('img');
        var label = document.createElement('div');
        dot.className = 'custom-cursor custom-cursor__dot';
        ring.className = 'custom-cursor custom-cursor__ring';
        logo.className = 'custom-cursor custom-cursor__logo';
        logo.src = 'img/yul-logo_blue.svg';
        logo.alt = '';
        logo.setAttribute('aria-hidden', 'true');
        label.className = 'custom-cursor custom-cursor__label';
        label.setAttribute('aria-hidden', 'true');
        document.body.appendChild(ring);
        document.body.appendChild(label);
        document.body.appendChild(logo);
        document.body.appendChild(dot);

        var x = 0;
        var y = 0;
        var ringX = 0;
        var ringY = 0;
        var hasPointer = false;
        var hoverSelector = 'a, button, input, textarea, select, label, [role="button"], [tabindex]:not([tabindex="-1"])';

        function placeCursor(el, px, py, scale) {
            el.style.transform = 'translate3d(' + px + 'px, ' + py + 'px, 0) translate(-50%, -50%) scale(' + scale + ')';
        }

        function setHoverState(target) {
            var isHovering = !!(target && target.closest && target.closest(hoverSelector));
            dot.classList.toggle('is-hovering', isHovering);
            ring.classList.toggle('is-hovering', isHovering);
            logo.classList.toggle('is-hovering', isHovering);
            label.classList.toggle('is-hovering', isHovering);
        }

        function tick() {
            ringX += (x - ringX) * 0.16;
            ringY += (y - ringY) * 0.16;
            placeCursor(dot, x, y, 1);
            placeCursor(label, x, y, 0.96);
            placeCursor(logo, x, y, 0.9);
            placeCursor(ring, ringX, ringY, 1);
            requestAnimationFrame(tick);
        }

        document.addEventListener('mousemove', function (event) {
            x = event.clientX;
            y = event.clientY;
            if (!hasPointer) {
                hasPointer = true;
                ringX = x;
                ringY = y;
                dot.classList.add('is-visible');
                label.classList.add('is-visible');
                logo.classList.add('is-visible');
                ring.classList.add('is-visible');
            }
            setHoverState(event.target);
        }, { passive: true });

        document.addEventListener('mouseleave', function () {
            dot.classList.remove('is-visible');
            label.classList.remove('is-visible');
            logo.classList.remove('is-visible');
            ring.classList.remove('is-visible');
            hasPointer = false;
        });

        requestAnimationFrame(tick);
    }

    initCustomCursor();
});
